import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  openActivityForm() {
    App.Helpers.ajaxRequest({ url: this.newActivityURL, successHandler: this.emitActivityFormFetchSuccess.bind(this) });
  }

  emitActivityFormFetchSuccess(response) {
    document.dispatchEvent(createCustomEvent("sortable-card-list-new-activity-form-fetch:success", this.element, { html: response, listID: this.templateID }));
  }

  //
  // GETTERS AND SETTERS
  //

  get templateID() {
    return this.data.get("template-id");
  }

  get newActivityURL() {
    return this.data.get("new-activity-url");
  }
}



// WEBPACK FOOTER //
// ./app/components/templates/assets/javascript/templates-add-list-item-button-controller.js